export { default } from './InlineNotice';
